import { render, staticRenderFns } from "./staff_roster.vue?vue&type=template&id=3bbf0eac&scoped=true&"
import script from "./staff_roster.vue?vue&type=script&lang=ts&"
export * from "./staff_roster.vue?vue&type=script&lang=ts&"
import style0 from "./staff_roster.vue?vue&type=style&index=0&id=3bbf0eac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf0eac",
  null
  
)

export default component.exports